import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import {
    AuthorizationService,
    DocumentService,
    EquipmentService,
    AssociationService
} from './../../../../shared/index';

@Component({
    selector: 'documentassociation-index',
    templateUrl: './documentassociation-index.html',
    standalone: false
})

export class DocumentAssociationIndexComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = [];
    public docFlag: boolean;

    constructor(
        private _authorizationService: AuthorizationService,
        private _associationService: AssociationService
    ) { }

    ngOnInit(): void {
        localStorage.setItem('docFlag', 'true');
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        localStorage.removeItem('docFlag');
    }
}
